import directives from './module';

directives.component('projectItem', {
    bindings: {
        project: '<',
        showVisibility: '<',
        isStaffPicks: '<'
    },
    templateUrl: require('project-item.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/ProjectItem.ts